import { createFileRoute, redirect } from "@tanstack/react-router";

// The public services browse was retired in favour of topic-based discovery.
// Bookable services still exist per-therapist; clients now browse by topic on the
// homepage and filter therapists at /therapists?problemTag=...
export const Route = createFileRoute("/services")({
  beforeLoad: () => {
    throw redirect({ to: "/therapists" });
  },
});
